/* VERA ROMERO — interacciones propias (sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Entradas al hacer scroll ---------- */
  var revealObserver = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.vr-reveal:not(.vr-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vr-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('vr-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Carruseles de producto ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-vr-slider]').forEach(function (slider) {
      if (slider.dataset.vrReady) return;
      slider.dataset.vrReady = '1';
      var track = slider.querySelector('.vr-slider__track, [data-vr-track]');
      var bar = slider.querySelector('.vr-slider__bar');
      var scope = slider.closest('[data-vr-slider-scope]') || slider.closest('.vr-section') || slider;
      var prev = scope.querySelector('[data-vr-prev]');
      var next = scope.querySelector('[data-vr-next]');
      if (!track) return;
      function step() {
        var item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      }
      var countEl = scope.querySelector('[data-vr-count]');
      function update() {
        if (countEl) {
          var n = track.children.length, f = track.firstElementChild, best = 0, d = Infinity;
          Array.prototype.forEach.call(track.children, function (el, i) { var dd = Math.abs(el.offsetLeft - (f ? f.offsetLeft : 0) - track.scrollLeft); if (dd < d) { d = dd; best = i; } });
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = n - 1;
          countEl.textContent = (best + 1) + '/' + n;
        }
        if (!bar) return;
        var max = track.scrollWidth - track.clientWidth;
        var ratio = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.min(100, ratio * 100) + '%';
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
        bar.parentElement.style.visibility = max > 4 ? 'visible' : 'hidden';
      }
      // Desplazamiento programado: siempre a la posición EXACTA de una tarjeta (un punto
      // de anclaje del scroll-snap), así el «imán» no corrige y no hay temblores en iPhone.
      function items() { return Array.prototype.slice.call(track.children); }
      function offsetOf(el) { var f = track.firstElementChild; return el.offsetLeft - (f ? f.offsetLeft : 0); }
      function nearestIndex() {
        var list = items(), best = 0, d = Infinity;
        list.forEach(function (el, i) { var dd = Math.abs(offsetOf(el) - track.scrollLeft); if (dd < d) { d = dd; best = i; } });
        return best;
      }
      function glide(left) {
        var max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: Math.max(0, Math.min(max, Math.round(left))), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function goBy(dir) {
        var list = items(); if (!list.length) return;
        var i = Math.max(0, Math.min(list.length - 1, nearestIndex() + dir));
        glide(offsetOf(list[i]));
      }
      if (prev) prev.addEventListener('click', function () { goBy(-1); });
      if (next) next.addEventListener('click', function () { goBy(1); });

      // Las tarjetas del carrusel no llevan animación de entrada: se muestran siempre
      // (las que entran por el lateral no deben depender de que el navegador avise).
      track.querySelectorAll('.vr-reveal').forEach(function (el) {
        el.classList.add('vr-visible');
        if (revealObserver) revealObserver.unobserve(el);
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      // Rotación automática (opcional, desde el editor)
      var secs = parseInt(slider.dataset.autoplay || '0', 10);
      if (secs > 0 && !reduceMotion) {
        var paused = false, visible = true;
        var pause = function () { paused = true; }, resume = function () { paused = false; };
        // En móvil (sin ratón) un toque dispara mouseenter/focus y nunca su contrario:
        // solo pausamos por ratón/teclado en dispositivos con puntero real.
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          slider.addEventListener('mouseenter', pause); slider.addEventListener('mouseleave', resume);
          slider.addEventListener('focusin', pause); slider.addEventListener('focusout', resume);
        }
        // Táctil: solo se detiene MIENTRAS el dedo está encima; al soltar sigue enseguida
        var touching = false;
        track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
        track.addEventListener('touchend', function () { touching = false; }, { passive: true });
        track.addEventListener('touchcancel', function () { touching = false; }, { passive: true });
        if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(slider);
        var autoMq = slider.dataset.autoplayMax ? window.matchMedia('(max-width: ' + slider.dataset.autoplayMax + 'px)') : null;
        setInterval(function () {
          if (paused || touching || !visible || document.hidden || (autoMq && !autoMq.matches)) return;
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          if (atEnd) glide(0);
          else goBy(1);
        }, secs * 1000);
      }
    });
  }

  /* ---------- Parallax suave (CTA final) ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-vr-parallax]');
    if (!els.length || reduceMotion) return;
    var ticking = false;
    function run() {
      els.forEach(function (el) {
        var intensity = parseFloat(el.dataset.vrParallax || 0) / 100;
        var rect = el.parentElement.getBoundingClientRect();
        var center = rect.top + rect.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (center * -intensity) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(run); ticking = true; }
    }, { passive: true });
    run();
  }

  /* ---------- Página de producto ---------- */
  function formatMoney(cents, format) {
    format = format || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withCommas + '.' + parts[1];
        case 'amount_no_decimals': return withCommas;
        case 'amount_no_decimals_with_comma_separator': return withDots;
        case 'amount_with_comma_separator':
        default: return withDots + ',' + parts[1];
      }
    });
  }

  function initProduct() {
    var root = document.querySelector('[data-vr-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-vr-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var moneyFormat = root.dataset.moneyFormat;
    var form = root.querySelector('[data-vr-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var addBtn = root.querySelector('[data-vr-add]');
    var addLabel = addBtn ? addBtn.querySelector('[data-vr-add-label]') : null;
    var priceEl = root.querySelector('[data-vr-price]');
    var stockEl = root.querySelector('[data-vr-stock]');
    var errorEl = root.querySelector('[data-vr-error]');
    var sticky = document.querySelector('[data-vr-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-vr-sticky-btn]') : null;
    var stickyCompare = sticky ? sticky.querySelector('[data-vr-sticky-compare]') : null;
    var stickyOpts = sticky ? sticky.querySelector('[data-vr-sticky-opts]') : null;
    var stickyImg = sticky ? sticky.querySelector('[data-vr-sticky-img]') : null;
    var stickyQty = sticky ? sticky.querySelector('[data-vr-sticky-qty-input]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-vr-sticky-price]') : null;
    var lastMedia = null;
    function stackMode() { return root.classList.contains('vr-pdp--stack') && window.matchMedia('(min-width: 990px)').matches; }
    var txt = {
      add: root.dataset.txtAdd, soldout: root.dataset.txtSoldout, choose: root.dataset.txtChoose,
      adding: root.dataset.txtAdding, inStock: root.dataset.txtInstock, low: root.dataset.txtLow, out: root.dataset.txtOut
    };
    var lowThreshold = parseInt(root.dataset.lowStock || '0', 10);
    var needsChoice = root.dataset.requireChoice === 'true';
    var chosen = !needsChoice;

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('[data-vr-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      if (!product) return null;
      // Si falta alguna opción (p. ej. aún no se eligió talla), preferir una variante disponible
      var matches = product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
      return matches.find(function (v) { return v.available; }) || matches[0];
    }
    function markAvailability(opts) {
      if (!product) return;
      root.querySelectorAll('[data-vr-option]').forEach(function (fs, idx) {
        fs.querySelectorAll('.vr-opt__value').forEach(function (wrap) {
          var input = wrap.querySelector('input');
          var test = opts.slice(); test[idx] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
          });
          wrap.classList.toggle('is-off', !ok);
        });
      });
    }
    function setButton(state, variant) {
      var label = txt.add;
      var disabled = false;
      if (state === 'soldout') { label = txt.soldout; disabled = true; }
      if (state === 'choose') { label = txt.add; }
      if (addBtn) { addBtn.disabled = disabled; if (addLabel) addLabel.textContent = label; }
      if (stickyBtn) { stickyBtn.disabled = disabled; stickyBtn.querySelector('span').textContent = label; }
      var bn = root.querySelector('[data-vr-buynow]'); if (bn) bn.disabled = disabled;
    }
    function update() {
      var opts = currentOptions();
      markAvailability(opts);
      var variant = findVariant(opts);
      if (!variant) { var lowNone = root.querySelector('[data-vr-lowstock]'); if (lowNone) lowNone.hidden = true; setButton('soldout'); return; }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        var html = '<span class="vr-price__actual">' + formatMoney(variant.price, moneyFormat) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>';
          priceEl.classList.add('vr-price--oferta');
        } else { priceEl.classList.remove('vr-price--oferta'); }
        priceEl.innerHTML = html;
      }
      if (stickyPrice) {
        stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
        var onSale = (variant.compare_at_price || 0) > variant.price;
        stickyPrice.classList.toggle('is-sale', onSale);
        if (stickyCompare) { stickyCompare.hidden = !onSale; if (onSale) stickyCompare.textContent = formatMoney(variant.compare_at_price, moneyFormat); }
      }
      if (stickyOpts) stickyOpts.textContent = chosen ? variant.options.join(' · ') : stickyOpts.dataset.empty;
      if (stickyImg && variant.featured_media_id) {
        var vImg = root.querySelector('[data-media-id="' + variant.featured_media_id + '"] img');
        if (vImg) stickyImg.src = vImg.currentSrc || vImg.src;
      }
      var noteEl = root.querySelector('[data-vr-offer-note]');
      if (noteEl) noteEl.hidden = !((variant.compare_at_price || 0) > variant.price);
      var saveEl = root.querySelector('[data-vr-save]');
      if (saveEl) {
        var diff = (variant.compare_at_price || 0) - variant.price;
        saveEl.hidden = !(diff > 0);
        if (diff > 0) saveEl.innerHTML = (saveEl.dataset.label || 'Ahorras') + ' <strong>' + formatMoney(diff, moneyFormat) + '</strong>';
      }
      // Aviso «Pocas unidades» (bajo los pagos): stock real de la variante elegida, entre 1 y el límite
      var lowEl = root.querySelector('[data-vr-lowstock]');
      var realQty = product.inventory ? product.inventory[variant.id] : null;
      var isLow = variant.available && lowThreshold > 0 && typeof realQty === 'number' && realQty > 0 && realQty <= lowThreshold;
      if (lowEl) lowEl.hidden = !(chosen && isLow);
      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        var qty = realQty;
        if (!variant.available) { stockEl.textContent = txt.out; stockEl.classList.add('is-out'); }
        else if (!lowEl && lowThreshold > 0 && typeof qty === 'number' && qty > 0 && qty <= lowThreshold && txt.low) {
          stockEl.textContent = txt.low.replace('[n]', qty); stockEl.classList.add('is-low');
        } else { stockEl.textContent = txt.inStock; }
      }
      if (!variant.available) setButton('soldout');
      else if (!chosen) setButton('choose');
      else setButton('add');
      if (errorEl) errorEl.textContent = '';
      if (chosen && window.history && window.history.replaceState && product.variants.length > 1) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (variant.featured_media_id) {
        var slide = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        var gallery = root.querySelector('.vr-pdp__gallery');
        if (slide && gallery && !stackMode()) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }
    root.querySelectorAll('[data-vr-option] input').forEach(function (input) {
      input.addEventListener('change', function () {
        var labelSpan = input.closest('[data-vr-option]').querySelector('[data-vr-selected]');
        if (labelSpan) labelSpan.textContent = input.value;
        input.closest('[data-vr-option]').classList.remove('is-missing');
        if (errorEl) errorEl.textContent = '';
        if (needsChoice) {
          chosen = Array.prototype.every.call(root.querySelectorAll('[data-vr-option]'), function (fs) { return fs.querySelector('input:checked'); });
        }
        update();
        // Galería apilada (ordenador): al elegir otro color, baja hasta su foto; la compra sigue fija a la derecha
        var variant = findVariant(currentOptions());
        if (stackMode() && variant && variant.featured_media_id && variant.featured_media_id !== lastMedia) {
          lastMedia = variant.featured_media_id;
          var vs = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
          if (vs) window.scrollTo({ top: vs.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
        }
      });
    });

    function openCart(response) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && response.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(response);
      } else {
        window.location.href = root.dataset.cartUrl || '/cart';
      }
    }
    function addToCart(qty, toCheckout) {
      qty = Math.max(1, Math.min(99, parseInt(qty, 10) || 1));
      if (!chosen) {
        if (errorEl) errorEl.textContent = txt.choose;
        var firstEmpty = Array.prototype.find.call(root.querySelectorAll('[data-vr-option]'), function (fs) { return !fs.querySelector('input:checked'); });
        if (firstEmpty) {
          firstEmpty.classList.remove('is-missing'); void firstEmpty.offsetWidth; firstEmpty.classList.add('is-missing');
          firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      if (!idInput) return;
      if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = txt.adding; }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: qty }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || res.body.status) {
            if (errorEl) errorEl.textContent = res.body.description || res.body.message || 'Error';
            if (sticky && sticky.classList.contains('is-visible') && errorEl) errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            res.body.id = parseInt(idInput.value, 10);
            if (toCheckout) { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout'; return; }
            openCart(res.body);
            if (stickyQty) stickyQty.value = 1;
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { update(); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(1); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { addToCart(stickyQty ? stickyQty.value : 1); });
    var buyNow = root.querySelector('[data-vr-buynow]');
    if (buyNow) buyNow.addEventListener('click', function () { addToCart(1, true); });
    if (stickyQty) {
      sticky.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          stickyQty.value = Math.max(1, Math.min(99, (parseInt(stickyQty.value, 10) || 1) + parseInt(b.dataset.step, 10)));
        });
      });
      stickyQty.addEventListener('change', function () { stickyQty.value = Math.max(1, Math.min(99, parseInt(stickyQty.value, 10) || 1)); });
    }

    // Barra fija de compra: aparece solo cuando el botón principal ya quedó por encima de la pantalla
    if (sticky && addBtn && 'IntersectionObserver' in window && !sticky.dataset.vrObs) {
      sticky.dataset.vrObs = '1';
      var setSticky = function (show) {
        if (sticky.classList.contains('is-visible') === show) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('vr-sticky-on', show);
      };
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        setSticky(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(addBtn);
      // Respaldo para deslizamientos rápidos en móvil (el botón puede "saltar" el borde sin que el observador lo detecte)
      var ticking = false;
      var checkSticky = function () { ticking = false; setSticky(addBtn.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(checkSticky); } }, { passive: true });
      checkSticky();
    }

    // Galería editorial (ordenador): la columna derecha baja con la página hasta que su final
    // ("¿Necesitas ayuda?") llega al borde inferior de la pantalla y ahí se queda fija (CSS sticky).
    // Aquí solo se mide su altura; el scroll lo hace siempre la página.
    var infoCol = root.querySelector('.vr-pdp__info');
    if (infoCol && root.classList.contains('vr-pdp--stack') && !infoCol.dataset.vrFit) {
      infoCol.dataset.vrFit = '1';
      var fit = function () {
        if (!stackMode()) { root.style.removeProperty('--vr-info-h'); return; }
        root.style.setProperty('--vr-info-h', infoCol.offsetHeight + 'px');
        if (sticky) root.style.setProperty('--vr-sticky-h', sticky.offsetHeight + 'px');
      };
      fit();
      window.addEventListener('resize', fit, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(infoCol);
    }

    // Galería: contador, miniaturas y flechas (+ filtro por color: solo las fotos del color elegido)
    var gallery = root.querySelector('.vr-pdp__gallery');
    var counter = root.querySelector('[data-vr-count]');
    var thumbWrap = root.querySelector('.vr-gal__thumbs');
    var thumbs = root.querySelectorAll('[data-vr-thumb]');
    var allSlides = gallery ? Array.prototype.slice.call(gallery.children) : [];
    var allThumbs = Array.prototype.slice.call(thumbs);
    var galFilter = !!(gallery && gallery.hasAttribute('data-vr-gal-filter'));
    function vrSlug(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function goTo(i) {
      if (!gallery) return;
      var n = gallery.children.length;
      i = (i + n) % n;
      gallery.scrollTo({ left: i * gallery.clientWidth, behavior: 'smooth' });
    }
    function current() { return gallery ? Math.round(gallery.scrollLeft / gallery.clientWidth) : 0; }
    function refreshGallery() {
      if (!gallery) return;
      var i = current();
      var kids = gallery.children;
      if (counter) counter.textContent = Math.min(i + 1, kids.length) + ' / ' + kids.length;
      var curIdx = kids[i] ? kids[i].dataset.index : null;
      (thumbWrap ? Array.prototype.slice.call(thumbWrap.children) : allThumbs).forEach(function (t) {
        var on = t.dataset.vrThumb === curIdx;
        t.classList.toggle('is-active', on);
        if (on && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          t.parentElement.scrollTo({ left: t.offsetLeft - 40, top: t.offsetTop - 40, behavior: 'smooth' });
        }
      });
      if (counter) counter.hidden = kids.length < 2;
    }
    function applyColor(col) {
      if (!galFilter || !col) return;
      var keep = function (el) { var c = el.dataset.vrColor || ''; return !c || c === col; };
      if (!allSlides.some(function (s) { return s.dataset.vrColor === col; })) return;
      while (gallery.firstChild) gallery.removeChild(gallery.firstChild);
      allSlides.forEach(function (s) { if (keep(s)) { s.hidden = false; gallery.appendChild(s); } });
      if (thumbWrap) {
        while (thumbWrap.firstChild) thumbWrap.removeChild(thumbWrap.firstChild);
        allThumbs.forEach(function (t) { if (keep(t)) { t.hidden = false; thumbWrap.appendChild(t); } });
      }
      root.querySelectorAll('[data-lb-id]').forEach(function (im) { im.hidden = !keep(im); });
      gallery.scrollLeft = 0;
      refreshGallery();
    }
    function checkedColor() {
      var fs = root.querySelector('.vr-opt--color');
      var c = fs ? fs.querySelector('input:checked') : null;
      return c ? vrSlug(c.value) : null;
    }
    if (galFilter) {
      applyColor(checkedColor());
      root.querySelectorAll('.vr-opt--color input').forEach(function (inp) {
        inp.addEventListener('change', function () { applyColor(vrSlug(inp.value)); });
      });
    }
    if (gallery) {
      gallery.addEventListener('scroll', refreshGallery, { passive: true });
      allThumbs.forEach(function (t) { t.addEventListener('click', function () {
        var kids = Array.prototype.slice.call(gallery.children);
        var pos = kids.findIndex(function (k) { return k.dataset.index === t.dataset.vrThumb; });
        if (pos > -1) goTo(pos);
      }); });
      var gp = root.querySelector('[data-vr-gal-prev]'), gn = root.querySelector('[data-vr-gal-next]');
      if (gp) gp.addEventListener('click', function () { goTo(current() - 1); });
      if (gn) gn.addEventListener('click', function () { goTo(current() + 1); });
    }

    // Zoom a pantalla completa (escritorio)
    var lightbox = root.querySelector('[data-vr-lightbox]');
    if (lightbox && gallery) {
      gallery.addEventListener('click', function (e) {
        var slide = e.target.closest('.vr-pdp__slide');
        if (!slide) return;
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var target = lightbox.querySelector('[data-lb-id="' + slide.dataset.mediaId + '"]');
        if (target) setTimeout(function () { target.scrollIntoView(); }, 10);
      });
      lightbox.querySelector('.vr-lightbox__close').addEventListener('click', function () {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Guía de tallas
    root.querySelectorAll('[data-vr-open-dialog]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dlg = document.getElementById(btn.dataset.vrOpenDialog);
        if (dlg && dlg.showModal) dlg.showModal();
      });
    });
    document.querySelectorAll('.vr-dialog').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    });

    update();
  }

  /* ---------- Recomendaciones (También te puede gustar) ---------- */
  function initReco() {
    document.querySelectorAll('[data-vr-reco]').forEach(function (box) {
      if (box.dataset.vrReady) return;
      box.dataset.vrReady = '1';
      var hide = function () { var w = box.closest('.shopify-section'); if (w) w.style.display = 'none'; };
      // Nunca recomendar la prenda que se está viendo, no repetir las de «Completa tu look» y respetar el número elegido
      var tidy = function () {
        var grid = box.querySelector('.vr-grid');
        if (!grid) { hide(); return; }
        var here = window.location.pathname.replace(/\/$/, '');
        var limit = parseInt(box.dataset.limit || '0', 10);
        Array.prototype.slice.call(grid.children).forEach(function (card) {
          var a = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
          if (!a) return;
          var path = a.pathname.replace(/\/$/, '');
          if (here.indexOf('/products/') > -1 && path === here) { card.remove(); return; }
          if (document.querySelector('[data-vr-look] a[href*="' + path + '"]')) card.remove();
        });
        if (limit) Array.prototype.slice.call(grid.children, limit).forEach(function (card) { card.remove(); });
        if (!grid.children.length) { hide(); return; }
        initReveal(box);
      };
      // Si Shopify ya envió las recomendaciones con la página, solo se ordenan; si no, se piden
      if (box.querySelector('.vr-grid')) { tidy(); return; }
      fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-vr-reco]');
        if (fresh && fresh.querySelector('.vr-grid')) { box.innerHTML = fresh.innerHTML; tidy(); } else { hide(); }
      }).catch(hide);
    });
  }

  /* ---------- Pie: columnas desplegables en móvil ---------- */
  function initFooter() {
    var cols = document.querySelectorAll('.vr-footer__col');
    if (!cols.length) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() { cols.forEach(function (d) { d.open = !mq.matches; }); }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
  }


  /* ---------- Esperar a que la visitante responda al aviso de cookies ---------- */
  function cookieBannerVisible() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var cs = getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
  }
  function afterCookieChoice(cb) {
    var done = false, waited = 0;
    function go() { if (done) return; done = true; document.removeEventListener('visitorConsentCollected', onConsent); cb(); }
    function onConsent() { setTimeout(go, 1200); }
    document.addEventListener('visitorConsentCollected', onConsent);
    (function check() {
      if (done) return;
      // el aviso se inyecta con algo de retraso: esperamos al menos 2,5 s antes de dar por hecho que no existe
      if (cookieBannerVisible()) { waited = 0; setTimeout(check, 700); return; }
      waited += 700;
      if (waited >= 3500) go(); else setTimeout(check, 700);
    })();
  }

  /* ---------- Popup de bienvenida ---------- */
  function initPopup(force) {
    var pop = document.querySelector('[data-vr-popup]');
    if (!pop || (pop.dataset.vrReady && !force)) return;
    pop.dataset.vrReady = '1';
    var key = pop.dataset.key || 'vrPopup';
    var days = parseInt(pop.dataset.days || '3', 10);
    var sessKey = key + '-sesion';
    var delay = parseInt(pop.dataset.delay || '5', 10) * 1000;
    var design = pop.dataset.design === 'true';
    var box = pop.querySelector('.vr-pop__box');
    var form = pop.querySelector('[data-vr-pop-form]');
    var success = pop.querySelector('[data-vr-pop-success]');
    var error = pop.querySelector('[data-vr-pop-error]');
    var lastFocus = null;
    function read() { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (e) { return {}; } }
    function save(v) { try { localStorage.setItem(key, JSON.stringify(v)); } catch (e) {} }
    function flag(name, v) { try { if (v === undefined) return sessionStorage.getItem(name); sessionStorage.setItem(name, v); } catch (e) { return null; } }
    function open() {
      if (pop.classList.contains('is-open')) return;
      var cd = document.querySelector('cart-drawer.active, .menu-drawer-container[open], details[open] > .search-modal');
      if (cd) return; // nunca encima del carrito lateral, el menú o la búsqueda
      lastFocus = document.activeElement;
      if (!design) { flag(sessKey, '1'); var cur = read(); if (!cur.done && !cur.closed) { cur.shown = Date.now(); save(cur); } }
      pop.hidden = false;
      document.body.classList.add('vr-pop-lock');
      void pop.offsetWidth;
      setTimeout(function () { pop.classList.add('is-open'); }, 20);
      if (!(timerMins > 0 && window.matchMedia('(max-width: 749px)').matches)) // en móvil, sin teclado de golpe en el estilo con contador
        setTimeout(function () { var f = pop.querySelector('input[type=email]') || box; try { f.focus({ preventScroll: true }); } catch (e) {} }, 350);
      startTimer();
    }
    // Contador del estilo «Urgencia»: empieza al abrirse; al llegar a 0 la oferta del popup caduca
    var timerMins = parseInt(pop.dataset.timer || '0', 10);
    var timerEl = pop.querySelector('[data-vr-pop-timer]');
    var step1 = pop.querySelector('[data-vr-pop-step1]');
    var timerInt = null;
    function startTimer() {
      if (!(timerMins > 0) || !timerEl || !step1 || timerInt) return;
      var endKey = key + '-fin', end = parseInt(flag(endKey) || '0', 10);
      if (!end || end < Date.now() - 60000) { end = Date.now() + timerMins * 60000; if (!design) flag(endKey, String(end)); }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.max(0, end - Date.now()), sec = Math.ceil(left / 1000);
        timerEl.textContent = pad(Math.floor(sec / 60)) + ':' + pad(sec % 60);
        pop.classList.toggle('is-urgent', sec <= 30);
        if (left <= 0) {
          clearInterval(timerInt);
          if (design) return;
          var ex = pop.querySelector('[data-vr-pop-expired]'); if (ex) ex.hidden = false;
          step1.classList.add('is-expired');
          step1.querySelectorAll('input, button[type=submit]').forEach(function (el) { el.disabled = true; });
          setTimeout(function () { close(true); }, 2600);
        }
      }
      tick(); timerInt = setInterval(tick, 250);
    }
    function close(remember) {
      pop.classList.remove('is-open');
      document.body.classList.remove('vr-pop-lock');
      setTimeout(function () { pop.hidden = true; }, 450);
      if (remember && !design) {
        var st = read();
        if (!st.done) save({ closed: Date.now() });
        flag(sessKey, '1');
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      setTimeout(showTab, 460);
    }
    // Pestaña lateral: una sola lógica con el popup (mismo estado guardado)
    var tab = document.querySelector('[data-vr-pop-tab]');
    function showTab() {
      if (!tab || design || /^\/cart/.test(location.pathname)) return;
      var done = !!read().done;
      if (pop.dataset.tabDoneOnly === 'true' && !done) { tab.hidden = true; return; }
      tab.firstElementChild.textContent = done ? tab.dataset.done : tab.dataset.text;
      tab.dataset.mode = done ? 'done' : 'open';
      tab.setAttribute('aria-label', done ? tab.dataset.done : tab.dataset.text);
      tab.hidden = false;
    }
    if (tab) tab.addEventListener('click', function () {
      if (tab.dataset.mode === 'done') {
        location.href = '/discount/' + encodeURIComponent(tab.dataset.code) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
        return;
      }
      tab.hidden = true;
      open();
    });
    pop.querySelectorAll('[data-vr-pop-close]').forEach(function (b) { b.addEventListener('click', function () { close(true); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(true); });
    if (form) form.addEventListener('submit', function () { flag('vrPopSent', '1'); });

    var copy = pop.querySelector('[data-vr-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = pop.querySelector('[data-vr-code]').textContent.trim();
      var done = function () { copy.textContent = copy.dataset.done || 'OK'; copy.classList.add('is-done'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
      else fallback();
      function fallback() {
        var t = document.createElement('textarea'); t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (e) {} document.body.removeChild(t);
      }
    });

    // Vuelta tras enviar el email (la página se recarga con el resultado)
    var sent = flag('vrPopSent') === '1';
    if (sent && (success || error)) {
      if (success) { save({ done: true, at: Date.now() }); try { sessionStorage.removeItem('vrPopSent'); } catch (e) {} }
      open();
      return;
    }
    if (/[?&]ver_popup=1/.test(location.search)) { setTimeout(open, 800); return; } // enlace de prueba: siempre lo muestra
    if (design) return; // en el editor solo se abre al seleccionar la sección
    if (/customer_posted=true/.test(location.search) && success) save({ done: true, at: Date.now() });
    var st = read();
    if (st.done) { showTab(); return; }                    // ya se suscribió: nunca más (la pestaña muestra su código)
    if (flag(sessKey) === '1') { showTab(); return; }       // ya se mostró en esta visita
    if (st.closed) { showTab(); return; }                  // lo cerró alguna vez: no vuelve a salir
    if (st.shown && (Date.now() - st.shown) < 7 * 86400000) { showTab(); return; } // como máximo 1 vez cada 7 días
    if (/^\/cart/.test(location.pathname)) return;          // nunca en la página del carrito
    var trig = pop.dataset.trigger || 'tiempo';
    afterCookieChoice(function () {
      if (trig === 'tiempo' || trig === 'ambos') setTimeout(open, delay);
      if (trig === 'salida' || trig === 'ambos') armExit();
    });
    // Intención de salida: en ordenador, cuando el ratón sale por arriba (hacia pestañas/cerrar);
    // en móvil, cuando sube rápido hacia la barra del navegador. Solo tras unos segundos en la página.
    function armExit() {
      var ready = Date.now() - Math.round(performance.now()) + (parseInt(pop.dataset.minDelay || '25', 10) * 1000), fired = false; // nunca antes de N segundos desde que entró en la página
      var checking = false;
      function blocked() {
        if (/^\/cart/.test(location.pathname) || cookieBannerVisible()) return true;
        if (document.querySelector('cart-drawer.active')) return true;
        try { if (sessionStorage.getItem('vrAddedToCart') === '1') return true; } catch (e) {}
        return !!document.querySelector('#cart-icon-bubble .cart-count-bubble'); // ya tiene productos en el carrito
      }
      function fire() {
        if (fired || checking || Date.now() < ready || blocked()) return;
        checking = true;
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          checking = false;
          if (c && c.item_count > 0) return; // con productos en el carrito no sale
          if (blocked()) return;
          fired = true; cleanup(); open();
        }).catch(function () { checking = false; });
      }
      function onOut(e) { if (!e.relatedTarget && e.clientY <= 0) fire(); }
      var lastY = window.scrollY, lastT = Date.now();
      function onScroll() {
        var y = window.scrollY, t = Date.now();
        if (lastY - y > 140 && t - lastT < 250 && y < 600) fire();
        if (t - lastT > 120) { lastY = y; lastT = t; }
      }
      function cleanup() { document.removeEventListener('mouseout', onOut); window.removeEventListener('scroll', onScroll); }
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) document.addEventListener('mouseout', onOut);
      else window.addEventListener('scroll', onScroll, { passive: true });
    }
    pop._vrOpen = open; pop._vrClose = close;
  }
  document.addEventListener('shopify:section:select', function (e) {
    var pop = e.target.querySelector('[data-vr-popup]');
    if (pop) { initPopup(true); pop.hidden = false; pop.classList.add('is-open'); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var pop = e.target.querySelector('[data-vr-popup]');
    if (pop) { pop.classList.remove('is-open'); pop.hidden = true; document.body.classList.remove('vr-pop-lock'); }
  });

  /* ---------- Barra de oferta con contador ---------- */
  function initOffer() {
    var bar = document.querySelector('[data-vr-offer]');
    if (!bar || bar.dataset.vrReady) return;
    bar.dataset.vrReady = '1';
    var end = Date.parse(bar.dataset.end);
    var wrap = bar.closest('.shopify-section') || bar;
    function setH() { document.documentElement.style.setProperty('--vr-bar-h', (wrap.hidden || wrap.style.display === 'none') ? '0px' : bar.offsetHeight + 'px'); }
    var els = { d: bar.querySelector('[data-d]'), h: bar.querySelector('[data-h]'), m: bar.querySelector('[data-m]'), s: bar.querySelector('[data-s]') };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      if (isNaN(end) || diff <= 0) {
        if (bar.dataset.hide === 'true' && !(window.Shopify && window.Shopify.designMode)) { wrap.style.display = 'none'; setH(); clearInterval(t); }
        diff = 0;
      }
      var sec = Math.floor(diff / 1000);
      els.d.textContent = pad(Math.floor(sec / 86400));
      els.h.textContent = pad(Math.floor(sec % 86400 / 3600));
      els.m.textContent = pad(Math.floor(sec % 3600 / 60));
      if (els.s) els.s.textContent = pad(sec % 60);
    }
    var t = setInterval(tick, 1000);
    tick(); setH();
    window.addEventListener('resize', setH);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-vr-reviews-link]');
    if (!a) return;
    var t = document.getElementById('opiniones') || document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget, .jdgm-widget');
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  /* ---------- Plazo de envío: rango de fechas calculado cada día en el navegador ---------- */
  var VR_MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
  // Suma días a hoy; con "laborables" salta sábados y domingos (no contempla festivos)
  function vrAddDays(from, days, laborables) {
    var d = new Date(from);
    if (!laborables) { d.setDate(d.getDate() + days); return d; }
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    return d;
  }
  var VR_MESES_L = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  // Frase natural: «13 y el 27 de octubre» · «28 de octubre y el 10 de noviembre»
  function vrEtaText(minDays, maxDays, laborables) {
    var hoy = new Date(); hoy.setHours(12, 0, 0, 0);
    var a = vrAddDays(hoy, minDays, laborables);
    var b = vrAddDays(hoy, maxDays, laborables);
    var yA = a.getFullYear() !== b.getFullYear() ? ' de ' + a.getFullYear() : '';
    var yB = b.getFullYear() !== hoy.getFullYear() ? ' de ' + b.getFullYear() : '';
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) {
      return a.getDate() + ' y el ' + b.getDate() + ' de ' + VR_MESES_L[b.getMonth()] + yB;
    }
    return a.getDate() + ' de ' + VR_MESES_L[a.getMonth()] + yA + ' y el ' + b.getDate() + ' de ' + VR_MESES_L[b.getMonth()] + yB;
  }
  function initEta(root) {
    (root || document).querySelectorAll('[data-vr-eta]').forEach(function (box) {
      var out = box.querySelector('[data-vr-eta-range]');
      if (!out) return;
      var min = parseInt(box.dataset.min, 10) || 0, max = parseInt(box.dataset.max, 10) || min;
      if (max < min) { var t = min; min = max; max = t; }
      var lab = box.dataset.business === 'true';
      function paint() { out.textContent = vrEtaText(min, max, lab); box.classList.add('is-ready'); }
      paint();
      if (!box.dataset.vrTimer) {
        box.dataset.vrTimer = '1';
        // Si la pestaña sigue abierta al cambiar el día, se vuelve a calcular a medianoche
        var n = new Date(), next = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 0, 0, 5);
        setTimeout(function tick() { paint(); setTimeout(tick, 86400000); }, next - n);
      }
    });
  }

  /* ---------- Opiniones en lista: "Ver más" y formulario "Escribir una reseña" ---------- */
  function initReviewList(root) {
    (root || document).querySelectorAll('[data-vr-rl]').forEach(function (sec) {
      if (sec.dataset.vrReady) return;
      sec.dataset.vrReady = '1';
      var form = sec.querySelector('[data-vr-rl-form]');
      var openForm = function (scroll) {
        if (!form) return;
        form.hidden = false;
        if (scroll) {
          var bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--vr-bar-h')) || 0;
          window.scrollTo({ top: form.getBoundingClientRect().top + window.pageYOffset - bar - 24, behavior: 'smooth' });
        }
        var first = form.querySelector('input:not([type=hidden]), textarea');
        if (first && scroll) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      };
      sec.querySelectorAll('[data-vr-rl-open]').forEach(function (b) { b.addEventListener('click', function () { openForm(true); }); });
      var more = sec.querySelector('[data-vr-rl-more]');
      if (more) more.addEventListener('click', function () {
        sec.querySelectorAll('[data-vr-rl-item][hidden]').forEach(function (it) { it.hidden = false; });
        more.remove();
      });
      // Tras enviar (o si hay errores), mostrar el formulario con su mensaje
      if (form && form.querySelector('[data-vr-rl-state]')) openForm(true);
    });
  }

  // Personas viendo el producto: SOLO con una fuente real (enlace en el editor o window.vrViewersSource).
  // Sin fuente no se muestra nada. Respuesta admitida: número o {viewers|count|value: n}.
  function initViewers(root) {
    (root || document).querySelectorAll('[data-vr-viewers]').forEach(function (el) {
      if (el.dataset.vrInit) return;
      el.dataset.vrInit = '1';
      var out = el.querySelector('[data-vr-viewers-text]');
      var tpl = el.dataset.text || '[n]';
      var min = parseInt(el.dataset.min || '1', 10);
      var every = Math.max(15, parseInt(el.dataset.interval || '30', 10)) * 1000;
      if (el.hasAttribute('data-preview')) { out.textContent = tpl.replace('[n]', '12') + ' · vista previa'; el.hidden = false; return; }
      function show(n) {
        n = parseInt(n, 10);
        if (!(n >= min)) { el.hidden = true; return; }
        var t = tpl.replace('[n]', n);
        if (el.hidden) { out.textContent = t; el.hidden = false; return; }
        if (out.textContent === t) return;
        el.classList.add('is-updating');
        setTimeout(function () { out.textContent = t; el.classList.remove('is-updating'); }, 200);
      }
      function read(d) {
        if (d && typeof d === 'object') return d.viewers != null ? d.viewers : (d.count != null ? d.count : d.value);
        return d;
      }
      function poll() {
        if (document.hidden) return;
        var req;
        if (typeof window.vrViewersSource === 'function') {
          req = new Promise(function (ok) { ok(window.vrViewersSource({ productId: el.dataset.product, handle: el.dataset.handle })); });
        } else if (el.dataset.src) {
          var u = new URL(el.dataset.src, window.location.href);
          u.searchParams.set('product_id', el.dataset.product);
          u.searchParams.set('handle', el.dataset.handle);
          req = fetch(u.toString(), { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
        } else return;
        req.then(function (d) { show(read(d)); }).catch(function () { el.hidden = true; });
      }
      poll();
      setInterval(poll, every);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });
    });
  }

  // Opiniones «foco»: 3 tarjetas, la central destacada; giran solas de derecha a izquierda
  function initFoco(root) {
    (root || document).querySelectorAll('[data-vr-cf]').forEach(function (cf) {
      if (cf.dataset.vrInit) return;
      cf.dataset.vrInit = '1';
      var cards = Array.prototype.slice.call(cf.querySelectorAll('[data-vr-cf-card]'));
      var dots = Array.prototype.slice.call(cf.querySelectorAll('[data-vr-cf-dot]'));
      var n = cards.length; if (!n) return;
      var active = 0, paused = false, timer = null;
      var secs = Math.max(3, parseInt(cf.dataset.speed || '5', 10));
      function paint() {
        cards.forEach(function (c, i) {
          var d = (i - active + n) % n;
          if (d > n / 2) d -= n;
          c.classList.remove('is-center', 'is-left', 'is-right', 'is-off-l', 'is-off-r');
          c.classList.add(d === 0 ? 'is-center' : d === -1 ? 'is-left' : d === 1 ? 'is-right' : (d < 0 ? 'is-off-l' : 'is-off-r'));
          c.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
        });
        dots.forEach(function (dt, i) { dt.classList.toggle('is-active', i === active); dt.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
      }
      function go(i) { active = (i + n) % n; paint(); }
      function next() { go(active + 1); }
      function start() { stop(); if (n > 1 && !reduceMotion) timer = setInterval(function () { if (!paused && !document.hidden) next(); }, secs * 1000); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      dots.forEach(function (dt, i) { dt.addEventListener('click', function () { go(i); start(); }); });
      cards.forEach(function (c, i) { c.addEventListener('click', function () { if (i !== active) { go(i); start(); } }); });
      // Pausa por ratón solo en dispositivos con puntero real (en iPhone un toque dispara
      // mouseenter y nunca mouseleave → se quedaba parado para siempre)
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        cf.addEventListener('mouseenter', function () { paused = true; });
        cf.addEventListener('mouseleave', function () { paused = false; });
      }
      cf.addEventListener('touchcancel', function () { x0 = null; paused = false; start(); }, { passive: true });
      var x0 = null;
      cf.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; paused = true; }, { passive: true });
      cf.addEventListener('touchend', function (e) {
        if (x0 !== null) { var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(active + (dx < 0 ? 1 : -1)); }
        x0 = null; paused = false; start();
      }, { passive: true });
      paint(); start();
    });
  }

  /* ---------- Cuenta atrás del carrito («Te guardamos este artículo») ---------- */
  function initCartTimer() {
    if (window.vrCartTimerOn) return;
    window.vrCartTimerOn = true;
    var KEY = 'vrCartTimer';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
    function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    var mem = null;
    // Se guarda el momento en que se añadió el producto ({ start }); el final se calcula con los minutos del editor.
    // Cada vez que se añade un producto la cuenta vuelve a empezar desde el principio (10:00);
    // si el carrito se vacía se borra, para que la próxima compra no herede una cuenta a medias.
    var emptied = false; // carrito vaciado en esta página: no crear cuenta hasta el próximo «añadir»
    function restart() { emptied = false; mem = { start: Date.now() }; save(mem); tick(); try { sessionStorage.setItem('vrAddedToCart', '1'); } catch (e) {} }
    function clear() { emptied = true; mem = null; try { localStorage.removeItem(KEY); } catch (e) {} }
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function (res) {
            if (!res || !res.ok) return;
            if (/\/cart\/add/.test(url)) { restart(); return; }
            res.clone().json().then(function (c) { if (c && c.item_count === 0) clear(); }).catch(function () {});
          }).catch(function () {});
        }
        return p;
      };
    }
    // Formularios de compra que recargan la página (sin carrito lateral)
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.action && /\/cart\/add/.test(f.action)) restart();
    }, true);
    function tick() {
      var els = document.querySelectorAll('[data-vr-cart-timer]');
      if (!els.length || emptied) return;
      var now = Date.now();
      var mins = parseInt(els[0].dataset.minutes || '10', 10);
      var st = read() || mem;
      if (st && !st.start && st.end) st = { start: st.end - mins * 60000 }; // formato antiguo
      // Sin cuenta guardada (carrito de una visita anterior) o terminada hace más de 30 min: nueva cuenta.
      // Si acaba de terminar se queda en 0 con el mensaje final hasta que añada otro artículo.
      if (!st || !st.start || now >= st.start + mins * 60000 + 30 * 60000) { st = { start: now }; save(st); }
      mem = st;
      var left = Math.max(0, st.start + mins * 60000 - now);
      var m = Math.floor(left / 60000), sec = Math.floor((left % 60000) / 1000);
      var label = m + ':' + (sec < 10 ? '0' : '') + sec;
      els.forEach(function (el) {
        var live = el.querySelector('[data-vr-ct-live]'), done = el.querySelector('[data-vr-ct-done]'), head = el.querySelector('[data-vr-ct-head]');
        var t = el.querySelector('[data-vr-ct-time]');
        if (t && t.textContent !== label) t.textContent = label;
        var ended = left <= 0;
        if (live) live.hidden = ended;
        if (done) done.hidden = !ended;
        if (head) head.hidden = ended;
        el.classList.toggle('is-ended', ended);
        el.classList.toggle('is-urgent', !ended && left < 60000);
      });
    }
    tick();
    setInterval(tick, 500);
    // El carrito se vuelve a pintar al añadir/quitar artículos: actualizar al instante
    if ('MutationObserver' in window) new MutationObserver(function () { tick(); }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Cinta continua (Completa tu look) ---------- */
  function initMarquee(root) {
    (root || document).querySelectorAll('[data-vr-marquee]').forEach(function (m) {
      var track = m.querySelector('.vr-marq__track'), set = m.querySelector('.vr-marq__set');
      if (!track || !set) return;
      // La copia es solo visual: fuera del teclado y de los lectores de pantalla
      m.querySelectorAll('[data-vr-marq-clone] a, [data-vr-marq-clone] button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      function setDur() {
        var speed = parseFloat(m.dataset.speed || '30') || 30;
        track.style.setProperty('--vr-marq-dur', Math.max(8, set.getBoundingClientRect().width / speed) + 's');
      }
      setDur();
      if (!m.dataset.vrReady) { m.dataset.vrReady = '1'; window.addEventListener('resize', setDur); window.addEventListener('load', setDur); }
    });
  }

  /* ---------- Barra de envío gratis: repetir la animación de relleno al abrir el carrito lateral ---------- */
  function initShipbarFill() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.vrFsObs) return;
    drawer.dataset.vrFsObs = '1';
    var wasOpen = drawer.classList.contains('active');
    new MutationObserver(function () {
      var open = drawer.classList.contains('active');
      if (open && !wasOpen) {
        drawer.querySelectorAll('.vr-fs__bar i').forEach(function (el) {
          el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
        });
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Ficha: cuenta atrás real de la liquidación (misma fecha que la barra de oferta) ---------- */
  function initPdpUrgency() {
    var bar = document.querySelector('[data-vr-offer]');
    var barEnd = bar ? Date.parse(bar.dataset.end) : NaN;
    document.querySelectorAll('[data-vr-pdp-urg]').forEach(function (el) {
      if (el.dataset.vrReady) return;
      el.dataset.vrReady = '1';
      // Fecha propia (ajuste de la sección) o, si está vacía, la de la barra de oferta
      var end = el.dataset.end ? Date.parse(el.dataset.end) : barEnd;
      var dLabel = el.dataset.days || 'd';
      var out = el.querySelector('[data-vr-urg-time]');
      if (isNaN(end) || !out) return;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = end - Date.now();
        if (left <= 0) { el.hidden = true; clearInterval(t); return; }
        var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
        out.textContent = (d > 0 ? d + ' ' + dLabel + ' ' : '') + pad(h) + ' h ' + pad(m) + ' min ' + pad(sec) + ' s';
        el.hidden = false;
      }
      var t = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Carrito: cuenta atrás REAL de la liquidación (fecha de la barra de oferta) ---------- */
  function initCartLiq() {
    if (window.vrCartLiqOn) return;
    window.vrCartLiqOn = true;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var rows = document.querySelectorAll('[data-vr-liq]');
      if (!rows.length) return;
      var bar = document.querySelector('[data-vr-offer]');
      var end = bar ? Date.parse(bar.dataset.end) : NaN;
      var left = end - Date.now();
      rows.forEach(function (row) {
        var out = row.querySelector('[data-vr-liq-time]');
        if (isNaN(end) || left <= 0 || !out) { row.hidden = true; return; }
        var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
        out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
        row.hidden = false;
      });
    }
    tick(); setInterval(tick, 1000); // cada segundo busca de nuevo las filas (el cajón se vuelve a pintar al cambiar el carrito)
  }

  /* ---------- Aviso de cookies nativo de Shopify: texto corto (primera capa AEPD) ----------
     Solo cambia el TEXTO del aviso y la etiqueta de «Administrar preferencias». Los botones son los
     originales de Shopify (misma Customer Privacy API), no se crean ni se sustituyen. */
  function initCookieText() {
    var root = document.documentElement;
    var txt = root.dataset.vrCkText, link = root.dataset.vrCkLink, manage = root.dataset.vrCkManage;
    if (!txt) return;
    function apply() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b || b.dataset.vrDone) return !!b;
      var p = b.querySelector('.shopify-pc__banner__body p');
      var a = b.querySelector('#shopify-pc__banner__body-policy-link');
      if (p && a) {
        a.textContent = link || a.textContent;
        while (p.firstChild) p.removeChild(p.firstChild);
        p.appendChild(document.createTextNode(txt + ' '));
        p.appendChild(a);
        p.appendChild(document.createTextNode('.'));
      }
      var m = b.querySelector('#shopify-pc__banner__btn-manage-prefs span');
      if (m && manage) m.textContent = manage;
      b.dataset.vrDone = '1';
      return true;
    }
    if (apply()) return;
    var mo = new MutationObserver(function () { if (apply()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  /* ---------- Página del carrito: «Ahorras X €» se actualiza al cambiar cantidades o quitar prendas ----------
     Dawn solo repinta la parte de totales del pie; esta caja está fuera, así que la recogemos de la misma respuesta. */
  function initCartSavingSync() {
    if (window.vrSavingSync || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.vrSavingSync = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      var box = document.querySelector('[data-vr-total-saving]');
      if (!box) return;
      var id = box.dataset.section;
      function put(html) {
        var n = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-vr-total-saving]');
        if (n) box.innerHTML = n.innerHTML;
      }
      var secs = e && e.cartData && e.cartData.sections;
      if (secs && secs[id]) { put(secs[id]); return; }
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id)).then(function (r) { return r.text(); }).then(put).catch(function () {});
    });
  }

  /* ---------- Icono del carrito → página completa del carrito ----------
     Al AÑADIR una prenda se abre el carrito lateral (sin salir de la ficha); al pulsar el icono del
     carrito se va a /cart, como en las boutiques de referencia. Se intercepta antes que el cajón de Dawn. */
  function initCartIconToPage() {
    if (window.vrCartIconPage) return;
    window.vrCartIconPage = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#cart-icon-bubble');
      if (!a) return;
      e.preventDefault(); e.stopPropagation();
      window.location.href = a.getAttribute('href') || '/cart';
    }, true);
  }

  function initAll() {
    initFoco();
    initViewers();
    initReviewList();
    initEta();
    initOffer();
    initPopup();
    initReco();
    initFooter();
    initReveal();
    initSliders();
    initParallax();
    initProduct();
    initCartTimer();
    initCartLiq();
    initCookieText();
    initCartSavingSync();
    initCartIconToPage();
    initMarquee();
    initShipbarFill();
    initPdpUrgency();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Editor de Shopify: re-inicializar al editar secciones
  document.addEventListener('shopify:section:load', function (e) {
    initEta(e.target);
    initViewers(e.target);
    initFoco(e.target);
    initReviewList(e.target);
    initOffer();
    initReveal(e.target);
    initSliders(e.target);
    initMarquee(e.target);
    initReco();
    initFooter();
    initParallax();
    if (e.target.querySelector('[data-vr-product]')) initProduct();
  });
})();
